<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		d="M5.10427 11.005H16.2743L11.3943 6.12498C11.0043 5.73498 11.0043 5.09498 11.3943 4.70498C11.7843 4.31498 12.4143 4.31498 12.8043 4.70498C15.0676 6.96829 15.7432 7.64844 19.8955 12C14.6532 17.4476 14.1238 17.9754 12.8043 19.295C12.4143 19.685 11.7843 19.685 11.3943 19.295C11.0043 18.905 11.0043 18.275 11.3943 17.885L16.2743 13.005H5.10427C4.55427 13.005 4.10427 12.555 4.10427 12.005C4.10427 11.455 4.55427 11.005 5.10427 11.005Z"
		fill="currentColor"
	/>
</svg>
